(function($){


    // Prevent the 'Browse by' links
    $('.sub-nav__item > a').on('click', function(e){
        e.preventDefault();
    });


    //Append toggle-inner
    function appendDropdownHelper() {
        var $navbarList = $('.nav__list');
        var $menuDropdownHelper = $('<span class="nav__item--toggle"><span class="icon icon-chevron-down"></span></span>');

        $('a', $navbarList).each(function () {
            var $this = $(this);

            // has sub
            if ($this.next().is('div') || $this.next().is('ul')) {
                $this.after($menuDropdownHelper.clone());
            }
        });

        // click toggle
        $(document).on('click touchstart', '.nav__list .nav__item--toggle', function (e) {
            e.preventDefault();
            $(this).toggleClass('active').css('height', $(this).prev().outerHeight());
            $(this).next('.nav__sub, .nav__deep').slideToggle();
        });



        $('.nav__item').each(function() {
            if ($(this).has('ul.nav__sub').length) {
                $(this).addClass('nav__item--haschildren');
            }
        });

        $('.nav__sub-item').each(function() {
            if ($(this).has('ul.nav__deep').length) {
                $(this).addClass('nav__item--haschildren');
            }
        });

    };

    function openCurrentLevel() {
        // add selected class to the link
        var url = window.location.href;
        var $selectedItem = $('a[href="' + url + '"]').parent('li');        

        if ($selectedItem.hasClass('navbar__item')) {
            $selectedItem.addClass('current');
        } else {
            $selectedItem.addClass('selected');
        }
        
        var $selected = $('.nav__list').find('.selected');
        var $parents = $selected.parents();
        var $children;

        $parents.each(function() {
            $children = $(this).children('.nav__item--toggle');
            if ($children.length) {
                $children.addClass('active');
                $children.next('.nav__sub, .nav__deep').show();
            }
        });

    }


    appendDropdownHelper();
    openCurrentLevel();


    // As seen in the facets 'more' in search
    function makeFacetsList(displayedCategories) {
        var $showMore = $('<button class="nav__item--toggle" aria-control="hidden-nav" aria-expanded="false">More</button>');
        var $navSub = $('.nav__sub:visible');
        var $hidden = [];
        var counter = 0;
        var flagActive;

        // Loop through and hide items
        $navSub.each(function(i) {
            var $this = $(this);
            var $items = $this.children('li:gt('+displayedCategories+')');

            // Make sure all items are displayed
            $this.find('li').show();
            // Hide all items
            $items.addClass('visuallyhidden');
            $items.attr('aria-hidden', 'true');
            // Store the count value
            counter = $this.children().length;
            // Push the hidden items in $hidden
            $hidden.push($items);
        });

        // Append show hide more button
        if (counter > 8) {
            $navSub.after($showMore); 
            $navSub.attr('id', 'hidden-nav');
            $showMore.on('click', function(e) {
                var $this = $(this);
                // Set classes and attributes
                $this.toggleClass('active');
                $this.attr('aria-hidden', 'false');
                $.each($hidden, function(index, value) {
                    var $this = $(this);
                    $this.toggleClass('visuallyhidden');
                    $this.attr('aria-hidden', function(index, attr){
                        return attr === 'false' ? 'true' : 'false';
                    });
                    
                });
                // Set text values
                $this.text(function(i, txt) {
                    return txt === 'More' ? 'Less' : 'More';
                });
                e.preventDefault();
            });
            $.each($hidden, function(index, value) {
                var $this = $(this);
                if ($this.hasClass('nav__sub-item--active')) {
                    $showMore.click();    
                }
            });
        }
    }

    //makeFacetsList(7);

}(jQuery));
